<template>
  <el-card>
    <page-main
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        :dictData="selected"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="600px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <dict-options-edit-form
        ref="editForm"
        :metadataType="editFormDialogOptions.metadataType"
        :optionCode="editFormDialogOptions.code"
        :disabled="editFormDialogOptions.disabled"
        :params="editFormDialogOptions.params"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import DictOptionsEditForm from '../metadata-options-edit-form'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    DictOptionsEditForm
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: ''
      }
    }
  },
  computed: {
    selected() {
      return store.state.selected
    }
  },
  watch: {
    selected() {
      this.getData()
    }
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.metadataType) return
      this.loading = true
      this.$api
        .materialOptionsListApi({
          metadataType: this.selected.metadataType,
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      if (!this.selected || !this.selected.metadataType) {
        this.$message.warning(
          this.$l('form_label_please_material_attribute') ||
            '请选选择一个物料属性'
        )
        return
      }
      const types = {
        edit:
          this.$l('form_label_information_attribute_Edit') ||
          '编辑物料属性选项信息',
        add:
          this.$l('form_label_information_attribute_add') ||
          '添加物料属性选项信息',
        detail:
          this.$l('form_label_information_attribute_detail') ||
          '物料属性选项详情'
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.optionCode,
        metadataType: this.selected.metadataType,
        disabled: type === 'detail'
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    }
  }
}
</script>
